import { resetFilter } from './resetFilter';
import { resetSelectCar } from './resetSelectCar';
import { resetSelectedMobileLocation } from './resetSelectedMobileLocation';
import { setActiveDisplay } from './setActiveDisplay';
import { setFilter } from './setFilter';
import { setSearchValue } from './setSearchValue';
import { setSelectCar } from './setSelectCar';
import { setSelectedMobileLocation } from './setSelectedMobileLocation';
import { setSortOrder } from './setSortOrder';

export const myFleetOperations = {
  setFilter,
  setSearchValue,
  setSortOrder,
  setActiveDisplay,
  resetFilter,
  setSelectCar,
  resetSelectCar,
  setSelectedMobileLocation,
  resetSelectedMobileLocation
};
